import colorModel from './colorModel.vue';
export default {
  components: {
    colorModel
  },
  props: {
    configureList: {
      type: Array,
      default() {
        return [];
      }
    },
    styleObj: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      form: {},
      colorShow: false
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.form = this.styleObj;
    });
  },
  methods: {
    changeFun() {
      this.$emit('itemChange', this.form);
    },
    imgClick(val, id) {
      this.form.controlsComponentsMark = val;
      this.form.controlsComponentsId = id;
      this.changeFun();
    },
    changeClausFun(e) {
      this.form.isHiddenClause = e.target.checked;
      this.changeFun();
    },
    colorClickFun(val, key) {
      this.colorShow = true;
      this.$nextTick(() => {
        this.$refs.colorRef.init(val, key);
      });
    },
    colorFun(val, key) {
      this.form[key] = val;
      this.changeFun();
      this.colorShow = false;
    }
  }
};